const responses = [
    {id: 1, title: 'Checkout Page Response'},
    {id: 2, title: 'Preload Page Response'},
    {id: 3, title: 'Receipt Page Response'}
]

export default responses